import React, { useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import DownloadModal from '../Modals/ConfirmationModal/DownloadModal';

const EBookSlider = ({ getAllEBookList }) => {
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [fileUrl, setFileUrl] = useState();

    return (
      <>
        <div
          className="col-md-12 mt-5"
          data-aos="fade-down"
          data-aos-duration="1500"
        >
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={20}
            slidesPerView={3}
            autoHeight={false}
            navigation
            // autoplay={{ delay: 2500 }}
            // loop={true}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
            className="ct_coach_created_slider"
          >
            {getAllEBookList?.length != 0 &&
              getAllEBookList?.map((item, i) => (
                <SwiperSlide>
                  <div className="item">
                    <figure className="mb-0 ct_coach_created_card d-grid">
                      <div>
                        <div
                          className="ct_coach_created_img"
                          style={{ aspectRatio: "auto" }}
                        >
                          <img
                            src={item?.image || "assets/img/book_1.png"}
                            alt=""
                            style={{ height: "356px", objectPosition: "top" }}
                          />
                        </div>
                        <figcaption className="mt-3">
                          <div className="d-flex align-items-center gap-2 justify-content-between mb-2">
                            <p className="mb-0 ct_fs_18">{item?.title || ""}</p>
                          </div>
                          <p className="mt-1 mb-0 ct_fs_14">
                            By {item?.created_by || ""} /{" "}
                            {item?.created_role || ""} Coach
                          </p>
                          <p
                            className="mt-1 ct_fs_14 ct_para_scroll ct_custom_scroll"
                            style={{ maxWidth: "348px", maxHeight: "80px" }}
                          >
                            {item?.short_description || ""}
                          </p>
                        </figcaption>
                      </div>
                      <div className="mt-auto">
                        <a
                          className="ct_hover_link_darkblue ct_fs_14"
                          onClick={() => {
                            setConfirmationModal(true);
                            setFileUrl(item);
                          }}
                        >
                          Download eBook{" "}
                          <i className="fa-solid fa-arrow-right"></i>
                        </a>
                      </div>
                    </figure>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
        {confirmationModal && fileUrl && (
          <DownloadModal
            onClose={() => setConfirmationModal(false)}
            data={fileUrl}
          />
        )}
      </>
    );
};

export default EBookSlider;